import React, { useState } from "react";
import { Tabs } from "antd";
import Alsfrsr from "./sessions/Alsfrsr";
import KeyStatistics from "./sessions/KeyStatistics";
import Respiratory from "./sessions/Respiratory";
import MaximumPhonationTime from "./sessions/MaximumPhonationTime";

import englishJson from "../../utils/language/leStudy/english.json";
import spanishJson from "../../utils/language/leStudy/spanish.json";
import noLanguageJson from "../../utils/language/leStudy/noLanguage.json";
import { RESEARCH_TYPE } from "../../utils/consts";

const SessionList = (props) => {
  const onChange = (key) => {};
  const formData =
    RESEARCH_TYPE === "LE Study"
      ? props.language === "English"
        ? englishJson
        : props.language === "Spanish"
          ? spanishJson
          : noLanguageJson
      : englishJson;
  const relationToAls = localStorage.getItem("ap_relation_to_als");
  const ITEMS = [
    {
      key: 1,
      label: `${formData.page.personalDataViewer.keyStatics.title}`,
      children: (
        <KeyStatistics
          language={formData}
          eals_id={localStorage.getItem("ap_eals_id")}
        />
      ),
    },
    {
      key: 2,
      label: `${formData.page.personalDataViewer.respiratory.title}`,
      children: (
        <Respiratory
          language={formData}
          eals_id={localStorage.getItem("ap_eals_id")}
        />
      ),
    },
    {
      key: 3,
      label: `${formData.page.personalDataViewer.maximumPhonationTime.title}`,
      children: (
        <MaximumPhonationTime
          language={formData}
          eals_id={localStorage.getItem("ap_eals_id")}
        />
      ),
    },
    ...(relationToAls === "Living with ALS"
      ? [
          {
            key: 4,
            label: `${formData.page.personalDataViewer.alsfrsr.title}`,
            children: (
              <Alsfrsr
                language={formData}
                eals_id={localStorage.getItem("ap_eals_id")}
              />
            ),
          },
        ]
      : []),
  ];
  return (
    <div>
      <Tabs defaultActiveKey="1" items={ITEMS} onChange={onChange} />
    </div>
  );
};

export default SessionList;
